// @ts-nocheck

import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Header } from '../../components/layout';
import DailyBudgets from './DailyBudget/DailyBudgets';
import TimeLimits from './TimeLimit/TimeLimits';
import { TabItem, Tabs } from '../../components/ui';
import Assignments from './Assignment/Assignments';
import AnalysisTable from './Analysis/AnalysisTable';
import { connect } from 'react-redux';


import { showAssignments, showDailyBudgets, showTimeLimits } from './lib';
import OrgUnitSelect from '../../components/OrgUnitSelect';
import { accessTypeEnum } from '../../lib/enum';
import { RouteComponent } from '../../lib/routerAdapter';






const WorkPlans = ({ userAccess, employeeBranchOrgUnitId }) => {
  const canViewTimeLimits = showTimeLimits(userAccess);
  const canShowAssignments = showAssignments(userAccess);
  const canDailyBudgets = showDailyBudgets(userAccess);
  const [orgUnitId, setOrgUnitId] = useState(employeeBranchOrgUnitId);

  const isAdmin = userAccess.some((access) =>
  [accessTypeEnum.admin, accessTypeEnum.adminBranch].includes(access)
  );

  return (
    <>
      <Header
        left={<h1>План работ НТС</h1>}
        right={
        isAdmin &&
        <OrgUnitSelect
          style={{ width: 200 }}
          value={orgUnitId}
          onlyBranches
          onChange={(orgUnitId) => setOrgUnitId(orgUnitId)} />


        } />

      <Tabs withRouter>
        {canViewTimeLimits &&
        <TabItem
          label="Регламент"
          url="/contract-vehicle-work-plans/time-limit" />

        }
        {canShowAssignments &&
        <TabItem
          label="Закрепление"
          url="/contract-vehicle-work-plans/assignments" />

        }
        {canDailyBudgets &&
        <TabItem
          label="Планирование"
          url="/contract-vehicle-work-plans/daily-budgets" />

        }
        <TabItem label="Анализ" url="/contract-vehicle-work-plans/analysis" />
      </Tabs>
      <Routes>
        {canViewTimeLimits &&
        <Route
          path="time-limit"
          element={<RouteComponent component={TimeLimits} orgUnitId={orgUnitId} />} />

        }
        {canShowAssignments &&
        <Route
          path="assignments"
          element={<RouteComponent component={Assignments} orgUnitId={orgUnitId} />} />

        }
        {canDailyBudgets &&
        <Route
          path="daily-budgets/*"
          element={<RouteComponent component={DailyBudgets} orgUnitId={orgUnitId} />} />

        }
        <Route
          path="analysis"
          element={<RouteComponent component={AnalysisTable} orgUnitId={orgUnitId} />} />

      </Routes>
    </>);

};

export default connect((state) => ({
  userAccess: state.auth.profile.access,
  employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
}))(WorkPlans);
